/* eslint-disable vue/no-unused-vars */
<template>
  <div class="animated fadeIn">
    <b-modal
      title="Info!"
      class="modal-primary"
      v-model="charge"
      @ok="charge = false"
      ok-variant="primary"
      ok-only
    >
      Carregamento efetuado com sucesso.
    </b-modal>
    <div class="block-screen" v-if="loading">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">Datas de cadastro/escolha de voo</div>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Data de início do evento">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-mask="'99/99/9999 99:99:99'"
                    v-model="start_event"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Data do fim do evento">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-mask="'99/99/9999 99:99:99'"
                    v-model="final_event"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Data final do pré cadastro">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="final_register"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.final_register.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Data do primeiro voo">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="start_flight"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.start_flight.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Data do último voo">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="final_flight"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.final_flight.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Data para cálculo da idade">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="travel"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.travel.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="3">
              <b-form-fieldset label="Champion Início">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="start_champion"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.start_champion.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Champion final">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="final_champion"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.final_champion.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Super Início">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="start_super"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.start_super.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Super final">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="final_super"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.final_super.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Gold Início">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="start_gold"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.start_gold.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Gold final">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="final_gold"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.final_gold.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Silver Início">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="start_silver"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.start_silver.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Silver final">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="final_silver"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.final_silver.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Bronze Início">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="start_bronze"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.start_bronze.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>

            <b-col md="3">
              <b-form-fieldset label="Bronze final">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="final_bronze"
                    v-mask="'99/99/9999 99:99:99'"
                    :class="{ 'is-invalid': $v.final_bronze.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
          </b-row>

          <b-row class="form-group">
            <b-col md="12 text-right">
              <b-button variant="default" @click="back">
                <i class="fa fa-arrow-left"></i>&nbsp; Voltar
              </b-button>
              <b-button variant="primary" @click="create($v.$invalid)">
                <i class="fa fa-check"></i>&nbsp; Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!--/.col-->
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">Carga de participantes</div>
          <b-row class="form-group">
            <b-col md="12">
              <b-form-file
                v-model="userFile"
                browse-text="'Selecionar'"
                :state="Boolean(userFile)"
                placeholder="Selecione o arquivo ou arraste ele aqui..."
                drop-placeholder="'Arraste seu arquivo aqui...'"
                accept=".xls"
              ></b-form-file>
            </b-col>
          </b-row>

          <b-row class="form-group" v-if="Boolean(userFile)">
            <b-col md="12 text-right">
              <b-button variant="primary" @click="upload()">
                <i class="fa fa-upload"></i>&nbsp; Upload
              </b-button>
            </b-col>
          </b-row>

          <b-row class="form-group" v-if="users.length > 0">
            <b-col md="12">
              <!-- <ul>
                <li v-for="item in users" :key="item.code">
                  {{ item.user.code }} &ensp; {{item.user.name}} &ensp; {{item.user.e_mail}} &ensp;--- {{ item.status}}
                </li>
              </ul> -->
              <b-table striped hover :items="users" :fields="fields">
                <template #cell(user)="data">
                  <b class="text-info">{{ data }}</b>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!--/.col-->
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">Atualização de premiação</div>
          <b-row class="form-group">
            <b-col md="12">
              <b-form-file
                v-model="rankingFile"
                browse-text="'Selecionar'"
                :state="Boolean(rankingFile)"
                placeholder="Selecione o arquivo ou arraste ele aqui..."
                drop-placeholder="'Arraste seu arquivo aqui...'"
                accept=".xls"
              ></b-form-file>
            </b-col>
          </b-row>

          <b-row class="form-group" v-if="Boolean(rankingFile)">
            <b-col md="12 text-right">
              <b-button variant="primary" @click="uploadRanking()">
                <i class="fa fa-upload"></i>&nbsp; Upload
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!--/.col-->
    </b-row>
    <!--/.row-->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import { required } from "vuelidate/lib/validators";
import * as Helper from "./../../methods/helpers";

export default {
  name: "edit-configs",
  directives: {
    mask: AwesomeMask,
  },
  components: {},
  data() {
    return {
      userFile: null,
      rankingFile: null,
      loading: false,
      id: undefined,
      final_register: undefined,
      start_flight: undefined,
      final_flight: undefined,
      travel: undefined,
      start_champion: undefined,
      final_champion: undefined,
      start_super: undefined,
      final_super: undefined,
      start_gold: undefined,
      final_gold: undefined,
      start_silver: undefined,
      final_silver: undefined,
      start_bronze: undefined,
      final_bronze: undefined,
      final_event: undefined,
      start_event: undefined,
      users: [],
      fields: [
        { key: "user", label: "Participante", formatter: "fullName" },
        "status",
      ],
      charge: false,
    };
  },
  mounted() {
    this.loading = true;
    this.userId = this.$router.history.current.params.id;
    this.$http
      .get(`configs`)
      .then((response) => {
        this.loading = false;
        const { configs } = response.data;
        this.id = configs.id;
        this.final_register = Helper.formatDate(configs.final_register, true);
        this.start_flight = Helper.formatDate(configs.start_flight, true);
        this.final_flight = Helper.formatDate(configs.final_flight, true);
        this.travel = Helper.formatDate(configs.travel, true);
        this.start_champion = Helper.formatDate(configs.start_champion, true);
        this.final_champion = Helper.formatDate(configs.final_champion, true);
        this.start_super = Helper.formatDate(configs.start_super, true);
        this.final_super = Helper.formatDate(configs.final_super, true);
        this.start_gold = Helper.formatDate(configs.start_gold, true);
        this.final_gold = Helper.formatDate(configs.final_gold, true);
        this.start_silver = Helper.formatDate(configs.start_silver, true);
        this.final_silver = Helper.formatDate(configs.final_silver, true);
        this.start_bronze = Helper.formatDate(configs.start_bronze, true);
        this.final_bronze = Helper.formatDate(configs.final_bronze, true);
        this.start_event = Helper.formatDate(configs.start_event, true);
        this.final_event = Helper.formatDate(configs.final_event, true);
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
      });
  },
  methods: {
    back() {
      this.$router.push({
        name: "Dashboard",
      });
    },
    create(isInvalid) {
      if (isInvalid === false) {
        this.loading = true;
        this.$http
          .put(`configs`, {
            id: this.id,
            final_register: this.final_register,
            start_flight: this.start_flight,
            final_flight: this.final_flight,
            travel: this.travel,
            start_champion: this.start_champion,
            final_champion: this.final_champion,
            start_super: this.start_super,
            final_super: this.final_super,
            start_gold: this.start_gold,
            final_gold: this.final_gold,
            start_silver: this.start_silver,
            final_silver: this.final_silver,
            start_bronze: this.start_bronze,
            final_bronze: this.final_bronze,
            start_event: this.start_event,
            final_event: this.final_event,
          })
          .then(() => {
            this.loading = false;
            this.$router.push({
              name: "Dashboard",
            });
          })
          .catch((error) => {
            console.error(error);
            this.loading = false;
          });
      }
    },
    upload() {
      this.loading = true;
      let formData = new FormData();
      formData.append("excel", this.userFile);
      this.users = [];
      this.$http
        .post(`users/excel`, formData)
        .then((resp) => {
          this.loading = false;
          this.users = resp.data.users;
          this.charge = true;
          this.userFile = null;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
          this.userFile = null;  
        });
    },
    uploadRanking() {
      this.loading = true;
      let formData = new FormData();
      formData.append("excel", this.rankingFile);
      this.$http
        .post(`users/rank`, formData)
        .then((resp) => {
          this.loading = false;
          this.charge = true;
          this.rankingFile = null;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
          this.rankingFile = null;
        });
    },
    fullName(value) {
      return `${value.code} - ${value.name}    |    ${value.e_mail}`;
    },
  },
  validations() {
    return {
      final_register: { required },
      start_flight: { required },
      final_flight: { required },
      travel: { required },
      start_champion: { required },
      final_champion: { required },
      start_super: { required },
      final_super: { required },
      start_gold: { required },
      final_gold: { required },
      start_silver: { required },
      final_silver: { required },
      start_bronze: { required },
      final_bronze: { required },
      start_event: { required },
      final_event: { required },
    };
  },
};
</script>
<style>
.modal-lg {
  max-width: 1000px;
}
</style>


// WEBPACK FOOTER //
// src/views/configs/Edit.vue